module.exports = __webpack_public_path__ + "static/media/T+T_GraceBeck_-4.ae6eb368.JPG";